import { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { partnerConfigs } from "../../core/config";
import styled from "styled-components";
import { BurgerIcon, LogoIcon } from '../../components/Icons';
// import InputWithButton from "../../components/InputWithButton";
import AddressButton from "./components/AddressButton";
import Button from "../../components/Button";
import FloatingSocialButtons from "../../components/FloatingSocialButtons";
import ProfileButton from "./components/ProfileButton";
import CartButton from "./components/CartButton";
import MobileSidebar from "./components/MobileSidebar";
import Modal from "../../components/Modal";
import { Container } from "../../core/styles";
import Title from "../../components/Title";
import AppReco from "./components/AppReco";
import { setHeaderHeight } from "../../redux/reducer/slices/commonSlice";
import { formatPhoneNumber } from "../../core/utils";
import { MAIN_SERVER, resolveCurrentServer } from "../../utils/serverConfig";

const Header = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const currentParams = new URLSearchParams(location.search);
	const { isAuth } = useSelector((state) => state.profile);
	const { currentPartner } = useSelector((state) => state.partner);
	const { currentKitchen } = useSelector((state) => state.kitchens);
	const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
	const [isShowAppReco, setIsShowAppReco] = useState(localStorage.getItem('appRecoShowed') !== 'true');
	const [isDeliveryInfoModalOpen, setIsDeliveryInfoModalOpen] = useState(false);
	const [storedServer, setStoredServer] = useState(localStorage.getItem('currentServer') || '');
	const activeServer = useMemo(() => resolveCurrentServer(storedServer), [storedServer]);
	const isNonProductionServer = activeServer !== MAIN_SERVER;

	const hostname = window.location.hostname;
    const subdomain = hostname.split('.')[0];

	const getHeaderHeight = () => {
        const desktopHeight = document.querySelector("#desktop-header")?.offsetHeight || 0;
        const mobileHeight = document.querySelector("#mobile-header")?.offsetHeight || 0;
        return window.innerWidth > 798 ? desktopHeight : mobileHeight;
    };

    useEffect(() => {
		const syncServer = () => {
			setStoredServer(localStorage.getItem('currentServer') || '');
		};

		const syncServerFromStorage = (event) => {
			if (event.key && event.key !== 'currentServer') {
				return;
			}

			syncServer();
		};

		window.addEventListener('storage', syncServerFromStorage);
		window.addEventListener('currentServerChanged', syncServer);

		return () => {
			window.removeEventListener('storage', syncServerFromStorage);
			window.removeEventListener('currentServerChanged', syncServer);
		};
	}, []);

	useEffect(() => {
		const updateHeight = () => dispatch(setHeaderHeight(getHeaderHeight())); // Диспатч в стор
	
		updateHeight();
		window.addEventListener("resize", updateHeight);
	
		return () => {
			window.removeEventListener("resize", updateHeight);
		};
	}, [dispatch, isShowAppReco]);

	return (
		<>
			<DesktopWrapper id="desktop-header" $isNonProductionServer={isNonProductionServer}>
				<Container>
					<HeaderWrapper $isNonProductionServer={isNonProductionServer}>
						<LeftCol>
							{currentPartner && partnerConfigs[currentPartner] ? (
								<LogoWrapper>
									<Link to={"/"} style={{display: 'inline-flex', alignItems: 'center'}}>
										{partnerConfigs[currentPartner].logo && <img src={partnerConfigs[currentPartner].logo} alt={partnerConfigs[currentPartner].name} style={{height: 70, marginRight: 10}}/>}
										<Title style={{whiteSpace: 'nowrap'}}>{partnerConfigs[currentPartner].name}</Title>
									</Link>
								</LogoWrapper>
							) : (
								<LogoWrapper>
									<Link to={"/"}>
										<LogoIcon/>
									</Link>
								</LogoWrapper>
							)}	

							{/* <InputWithButton
								icon={SearchIcon}
								placeholder="Поиск блюд и кухонь"
								buttonText="Найти"
								onClick={handleSearch}
							/> */}

							<AddressButton/>
						</LeftCol>

						<RightCol>
							<CartButton/>
							<ProfileButton/>
						</RightCol>
					</HeaderWrapper>
					
					{currentPartner && partnerConfigs[currentPartner] &&
						<PartnerRow>
							{partnerConfigs[currentPartner].contactPhones?.length > 0 &&
								<PartnerPhones>
									{partnerConfigs[currentPartner].contactPhones.map((phone, idx) => (
										<PartnerPhone key={idx} href={`tel:${phone}`}>{formatPhoneNumber(phone)}</PartnerPhone>
									))}
								</PartnerPhones>
							}
							<PartnerLinks>
								<PartnerButton onClick={() => setIsDeliveryInfoModalOpen(true)}>Стоимость доставки</PartnerButton>
								<PartnerLink to={"/delivery"}>Зона доставки</PartnerLink>
							</PartnerLinks>
						</PartnerRow>
					}
				</Container>
			</DesktopWrapper>

			<MobileWrapper id="mobile-header" $isNonProductionServer={isNonProductionServer}>
				{isShowAppReco && !currentPartner && <AppReco onClose={() => setIsShowAppReco(false)}/>}

				<Content $isNonProductionServer={isNonProductionServer}>
					<Button style={{flex: 0}} size='small' type='icon' onClick={() => setIsMobileSidebarOpen(true)}><BurgerIcon/></Button>
					
					{location.pathname !== '/' ?
						<MobileLogoWrapper>
							<Link to={{ pathname: "/", search: currentParams.toString() }}>
								{currentPartner &&
									<Link to={"/"} style={{display: 'inline-flex', alignItems: 'center'}}>
										{currentPartner === 240289 && <img src={'https://stolovkin58.ru/pictures/logo_20230918162310.png'} alt={'stolovkin58'} style={{height: 45, marginRight: 8}}/>}
										<Title>{currentKitchen?.name}</Title>
									</Link>
								}
								{(
									subdomain === 'sitiy' ||
									subdomain === 'sitiy-test' ||
									subdomain === 'localhost'
								) &&
									<Link to={"/"}>
										<LogoIcon/>
									</Link>
								}
							</Link>
						</MobileLogoWrapper>
					: isAuth ? <AddressButton/> : <ProfileButton/>}

					<WrapperFloatingSocialButtons>
						<FloatingSocialButtons/>
					</WrapperFloatingSocialButtons>

					<CartButton/>

					<MobileSidebar isOpen={isMobileSidebarOpen} onClose={() => setIsMobileSidebarOpen(false)}/>
				</Content>
			</MobileWrapper>

			{/* Модальные окна */}
			<Modal isOpen={isDeliveryInfoModalOpen} onClose={() => setIsDeliveryInfoModalOpen(false)}>
				<ModalContent>
					<ModalTitle>Стоимость доставки</ModalTitle>
					<ModalText>
						<p>Доставка бесплатна. Всегда, любого заказа и по всей <PartnerLink to={"/delivery"}>зоне доставки</PartnerLink>.</p>
                        <p>Минимальная сумма заказа - 100 руб.</p>
                        <p>Заказы доставляются ежедневно по будням с 11:30 до 12:30.</p>
                        <p>После оплаты заказа передаётся в службу доставки Сытый, которая занимается доставкой наших заказов. Если вы заказывает впервые, то менеджер может вам позвонить для уточнения адреса и условий передачи заказа. При последующих заказах на этот адреса звонки для подтверждения не производятся</p>
                        <p>Обратите внимание: служба доставки "Сытый" (осуществляет доставку) может взимать дополнительно сервисный сбор (9 рублей) за заказ. При оплате заказа на сайте он будет сразу учтён.</p>
					</ModalText>
					<ModalTitle>Как оформить заказ</ModalTitle>
					<ModalText>
						<p>Мы принимаем заказы на текущий день до 10:00.</p>
						<p>Для оформления заказа добавьте товары в корзину и оплатите заказ удобным способом.</p>
						<p>Оплаченные заказы (в доставке и уже доставленные) отображаются в личном кабинете в разделе "Мои заказы".</p>
					</ModalText>
					<ModalTitle>Отмена заказа</ModalTitle>
					<ModalText>
						<p>Вы можете отменить заказ до 10:00 дня доставки. Средства по заказу вернуться автоматически на вашу карту, с которой вы оплачивали. При оплате по СБП средства возвращаются моментально. Если заказ оплачен картой и вы отменили заказ, то в большинстве случаев средства возвращаются в течении минуты. Иногда срок возврата может быть в течении 1-2 дней (зависит от работы банков)</p>
						<p>Приём оплаты и доставку заказа осуществляет сервис "Сытый". К оплате принимаются карты МИР, VISA, Mastercard. Эквайринг платежей на сайте осуществляется посредством банка "Т-Банк".</p>
					</ModalText>
				</ModalContent>
			</Modal>
		</>
	);
};

export default Header;

const DesktopWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 900;
	background-color: ${({ $isNonProductionServer }) => ($isNonProductionServer ? '#2f2f2f' : '#ffffff')};
	@media (max-width: 798px) {
		display: none;
	}
`;

const HeaderWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 10px 60px;
	flex-wrap: wrap;
	padding: 10px 0;
	background-color: ${({ $isNonProductionServer }) => ($isNonProductionServer ? '#2f2f2f' : '#ffffff')};
	min-height: 100px;
`;

const LeftCol = styled.div`
	flex: 1 1 auto;
	display: flex;
	align-items: center;
	gap: 20px;
`;

const LogoWrapper = styled.div`
	margin-right: auto;
	display: flex;
	align-items: center;
	width: fit-content;
`;

const PartnerRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 32px;
	padding-bottom: 20px;
	@media (max-width: 798px) {
		display: none;
	}
`;

const PartnerPhones = styled.div`
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
`;

const PartnerPhone = styled.a`
  color: #4CAF50;
  text-decoration: none;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
`;

const PartnerLinks = styled.div`
	margin-left: auto;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 20px;
	@media (max-width: 798px) {
		display: none;
	}
`;

const PartnerButton = styled.button`
	background: none;
	border: none;
	color: var(--color-text);
	text-decoration: underline;
	white-space: nowrap;
	cursor: pointer;
	font-size: inherit;
	font-family: inherit;
	
	&:hover {
		opacity: 0.7;
	}
`;

const PartnerLink = styled(Link)`
	color: var(--color-text);
	text-decoration: underline;
	white-space: nowrap;
`;

const ModalContent = styled.div`
	padding: 32px;
	max-width: 80vw;
	width: 100%;
	max-height: 80vh;
	overflow-y: auto;
`;

const ModalTitle = styled.h2`
	margin: 0 0 24px 0;
	font-size: 24px;
	font-weight: 600;
	color: #2C2E32;
`;

const ModalText = styled.div`
	margin: 0 0 32px 0;
	color: #464646;
	line-height: 1.6;
	
	p {
		margin: 0 0 16px 0;
		
		&:last-child {
			margin-bottom: 0;
		}
	}
	
	h4 {
		margin: 24px 0 16px 0;
		font-size: 18px;
		font-weight: 600;
		color: #2C2E32;
		
		&:first-child {
			margin-top: 0;
		}
	}
`;

const RightCol = styled.div`
	margin-left: auto;
	flex: 0;
	display: flex;
	align-items: center;
	gap: 20px;
	@media (max-width: 798px) {
		gap: 10px;
	}
`;

const MobileWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 900;
	display: none;
	flex-direction: column;
	background-color: ${({ $isNonProductionServer }) => ($isNonProductionServer ? '#262626' : '#ffffff')};
	@media (max-width: 798px) {
		display: flex;
	}
`;

const MobileLogoWrapper = styled.div`
	display: none;
	@media (max-width: 1024px) {
		display: flex;
		align-items: center;
		width: fit-content;
	}
`;

const Content = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 8px;
	padding: 24px 10px 12px;
	width: 100%;
	background-color: ${({ $isNonProductionServer }) => ($isNonProductionServer ? '#262626' : '#ffffff')};
`;

const WrapperFloatingSocialButtons = styled.div`
	position: relative;
	min-width: 45px;
	max-width: 45px;
	height: 45px;
`;